/**
 * Stream/exchange lifecycle constants — the status of the CURRENT in-flight exchange
 * (send → SSE stream → complete/error). Reset on conversation switch and mode change;
 * never persisted. Distinct from the backend's ConversationStatus (ACTIVE | ARCHIVED),
 * which is the conversation record's archival state.
 */
export const STREAM_STATUS = Object.freeze({
  IDLE: 'IDLE',
  CONNECTING: 'CONNECTING',
  STREAMING: 'STREAMING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
} as const);

export type StreamStatus = (typeof STREAM_STATUS)[keyof typeof STREAM_STATUS];

/**
 * Helper to check if status indicates streaming is in progress. Accepts any string so callers
 * can probe untrusted values (e.g. wire data) without casting.
 */
export const isStreamingStatus = (status: string): boolean => status === STREAM_STATUS.CONNECTING || status === STREAM_STATUS.STREAMING;
